<template>
  <section class="QuizThumbsUpDown ContentSection">
    <div class="QuizThumbsUpDown__quiz" v-if="!quizComplete">
      <transition-group :name="animations[direction].name">
        <article class="QuizThumbsUpDown__quiz__slide" v-for="slide in quizSlideshow" :key="slide.id">
          <h6 v-html="slide.text"></h6>
          <button @click="answerQuiz('skip')">
            Skip
            <img src="@/assets/img/ui/skip.svg" />
          </button>
        </article>
      </transition-group>

      <div class="QuizThumbsUpDown__quiz__navigation">
        <button class="QuizThumbsUpDown__quiz__navigation__button_down" @click="answerQuiz('down')">
          <img src="@/assets/img/ui/thumb.svg" />
        </button>
        <span v-html="quizProgress"></span>
        <button class="QuizThumbsUpDown__quiz__navigation__button_up" @click="answerQuiz('up')">
          <img src="@/assets/img/ui/thumb.svg" />
        </button>
      </div>
    </div>

    <div class="QuizThumbsUpDown__results" ref="results" v-else>
      <h5 v-html="properties.responseTitle"></h5>
      <p v-html="properties.responseSubtitle"></p>
      <div>
        <article v-for="accordion in sortedResponses" :key="accordion.title">
          <button @click="openAccordionClick(accordion)">
            <span v-html="accordion.score"></span>
            {{ accordion.title }}
            <img src="@/assets/img/ui/accordion-plus.svg" v-if="!accordion.open" />
            <img src="@/assets/img/ui/accordion-close.svg" v-else />
          </button>

          <div v-if="accordion.open">
            <div v-html="accordion.text" class="AccordionInfo__text" @click="linkTracking"></div>
          </div>
        </article>
      </div>


      <p class="double-space">Hent som pdf</p>

      <PDFGenerator :headerTitle="'Er vi et match?'" :color="pageData.color" :buttonText="'DOWNLOAD'"
        :PDFName="properties.responseTitle">

        <h3 class="pdf__element pdf__subtitle">{{ properties.responseTitle }}</h3>

        <template v-for="(accordion, i) in sortedResponses" :key="accordion.title">
          <article class="pdf__element pdf__listitem">

            <div class="pdf__listitem__title">
              <span>{{ accordion.score }} points</span>
              {{ accordion.title }}
            </div>

            <div class="pdf__listitem__text" v-html="accordion.text"></div>

          </article>

          <!-- page break hver 3 svar, men kun 2 på første side -->
          <div v-if="i % 3 == 1" class="html2pdf__page-break"></div>
        </template>

      </PDFGenerator>


    </div>


  </section>
</template>
<script>
import PDFGenerator from '../util/PDFGenerator.vue';
export default {
  props: ["properties", "pageData"],
  components: {
    PDFGenerator
  },
  data() {
    return {
      activeSlide: 0,
      slides: [],
      responses: [],
      quizComplete: false,
      openAccordion: null,

      resultsHTML: null,

      direction: "up",
      animations: {
        down: {
          name: "fadeOutLeft",
        },
        up: {
          name: "fadeOutRight",
        },
        skip: {
          name: "fadeOutUp",
        },
      },
    };
  },
  created() {

    //this.properties.slides.splice(0, 15);

    this.slides = this.properties.slides.map((slide, i) => {
      slide.id = `slide__${i}`;
      slide.score = null;
      return slide;
    });

    this.responses = this.properties.responses.map((response, i) => {
      response.id = `response__${i}`;
      response.score = 0;
      response.open = false;
      response.accordionOpen = false;
      return response;
    });
  },
  methods: {
    answerQuiz(thumb) {
      let score = null;

      switch (thumb) {
        case "up":
          score = this.slides[this.activeSlide].thumbsUp.split(/[\s,]+/);
          score = (score=='') ? [] : score;
          this.slides[this.activeSlide].score = score;
          break;

        case "down":
          score = this.slides[this.activeSlide].thumbsDown.split(/[\s,]+/);
          score = (score=='') ? [] : score;
          this.slides[this.activeSlide].score = score;
          break;

        case "skip":
          score = [];
          this.slides[this.activeSlide].score = score;
      }

      score = score.map(s => {
        return Number(s)
      })


      if (score !== null) this.countScore(score);

      this.direction = thumb;

      if (this.activeSlide == this.slides.length - 1) {
        this.endQuiz();
        return;
      }

      // Tracking that quiz started
      if(this.slides[1].score === null && this.activeSlide === 0)
        _paq.push(["trackEvent", "quiz", "quiz-started", window.app.vm.$route.path]);


      this.activeSlide++;
    },
    countScore(score) {
      score.forEach(slide => {
        this.responses[slide].score++;
      })
    },
    endQuiz() {
      this.quizComplete = true;
      _paq.push(["trackEvent", "quiz", "quiz-ended", window.app.vm.$route.path]);
      this.getHTML();
    },

    openAccordionClick(accordion) {
      let i = 0;
      while (i < this.responses.length) {
        if (accordion.id !== this.responses[i].id) {
          this.responses[i].open = false;
        } else {
          accordion.open = !accordion.open
        }

        i++;
      }
    },
    getHTML() {
      this.responses.forEach(r => {
        r.open = true;
      })
      this.resultsHTML = document.getElementById('app');
    },
    linkTracking(event) {
      // Check if the clicked element is a hyperlink
      if (event.target.tagName === "A") {
        // Handle the hyperlink click event
        const url = event.target.getAttribute("href");
        // You can do something with the href, for example, open it in a new tab
        _paq.push(["trackEvent", "external-link", window.app.vm.$route.path, url]);
      }
    }
  },
  computed: {
    quizSlideshow() {
      let slides = [];

      slides.push(this.slides[this.activeSlide]);
      return slides;
    },
    quizProgress() {
      let currentSlide = (this.activeSlide + 1).toString();
      let addPadding = currentSlide.length < 2 && this.slides.length >= 10;

      return `${addPadding ? "0" + currentSlide : currentSlide} | ${this.slides.length
        }`;
    },

    sortedResponses() {
      let responses = this.responses;

      responses.sort(function (a, b) {
        return b.score - a.score;
      });

      return responses;
    },
  },
};
</script>
<style lang="scss">
.QuizThumbsUpDown {
  display: flex;
  align-items: center;
  flex-direction: column;
  flex-grow: 1;
  padding-top: 120px;
  padding-bottom: 160px;
  background: var(--light-grey);

  &>div {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    max-width: var(--content-max-width);

    &.QuizThumbsUpDown__quiz {
      height: 280px;
      padding: var(--content-padding);

      &>article {
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #fff;
        width: 100%;
        width: calc(100% - 70px);
        max-width: 580px;
        height: 100%;
        box-shadow: var(--shadow-small);
        padding: 0 30px;

        h6 {
          font-size: 20px;
          font-weight: bold;
          line-height: 30px;
        }

        button {
          position: absolute;
          right: 20px;
          bottom: 20px;
          display: flex;
          align-items: center;
          cursor: pointer;

          &>img {
            margin-left: 14px;
          }
        }

        &.fadeOutLeft-enter-from {
          transform: translateX(200px);
        }

        &.fadeOutRight-leave-to {
          transform: translateX(200px) rotate(12deg) translateY(20px);
        }

        &.fadeOutRight-enter-from {
          transform: translateX(-200px);
        }

        &.fadeOutLeft-leave-to {
          transform: translateX(-200px) rotate(-12deg) translateY(20px);
        }
      }

      .QuizThumbsUpDown__quiz__navigation {
        position: absolute;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 480px;
        max-width: 100vw;
        padding: var(--content-padding);

        top: calc(100% + 14px);

        &>span {
          font-size: 20px;
          font-weight: bold;
        }

        &>button {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 72px;
          height: 72px;
          border-radius: 100%;
          background: #fff;
          box-shadow: var(--shadow-small);
          transition: var(--tk-easeinout) 0.2s transform;
          cursor: pointer;

          &:hover {
            transform: scale(1.05);
          }

          &.QuizThumbsUpDown__quiz__navigation__button_down {
            img {
              transform: rotate(180deg);
              margin-bottom: -6px;
            }
          }

          &.QuizThumbsUpDown__quiz__navigation__button_up {
            img {
              margin-top: -3px;
            }
          }
        }
      }
    }

    &.QuizThumbsUpDown__results {
      flex-direction: column;
      text-align: left;
      padding-bottom: 30px;

      >h5 {
        margin-bottom: 8px;
      }

      p {
        margin: 1em 0;

        &.double-space {
          margin: 2em 0 1em;
          ;
        }
      }


      &>div {
        width: 100%;
        max-width: var(--content-max-width);
        padding: var(--content-padding);


        &>article {
          width: 100%;
          border-top: solid 1px #000;
          border-bottom: solid 1px #000;

          &:first-of-type {
            border-bottom: none;
          }

          &:last-of-type {
            border-top: none;
          }

          &:nth-of-type(2) {
            border-top: solid 1px #000;
          }

          &>div {
            padding: 10px 0 40px 0;
          }

          &>button {
            position: relative;
            display: flex;
            align-items: center;
            font-size: 16px;
            font-weight: bold;
            height: 70px;

            &>span {
              display: flex;
              justify-content: center;
              align-items: center;
              width: 24px;
              height: 24px;
              border-radius: 100%;
              border: solid 2px #000;
              background: #fff;
              margin-right: 12px;
              padding-bottom: 4px;
            }

            &>img {
              position: absolute;
              right: 0;
              top: 50%;
              transform: translateY(-50%);
            }
          }
        }

        button {
          cursor: pointer;
          width: 100%;
        }
      }
    }
  }
}
</style>